import React from 'react'
import { AddressInput } from '@ztechapps/webui.location'
import { InlineDisplayContent, PhoneNumberInput } from '@ztechapps/webui.input'
import { useCheckoutContext } from '../../index'
import { formatPhoneNumber, validatePhoneNumber } from '@ztechapps/common.utils'
import { useToast } from '@ztechapps/common.hook'

export const ShippingAddressDisplayInput = () => {
  const context = useCheckoutContext()
  const [shippingOptions, setShippingOptions] = context.shippingOptions
  const { showError } = useToast()

  return (
    <>
      <InlineDisplayContent
        label="Phone Number"
        help="We will use this information to contact you if there are issue with shipping."
      >
        <PhoneNumberInput
          placeholder="Set your phone."
          value={shippingOptions?.phone}
          onChange={(e) => {
            setShippingOptions({ phone: e?.target.value })
          }}
          onBlur={(e) => {
            const phoneValue = e?.target.value

            if (phoneValue) {
              try {
                validatePhoneNumber(phoneValue)
                setShippingOptions({ phone: formatPhoneNumber(phoneValue) })
              } catch (e) {
                showError({
                  message: e.message,
                })
              }
            }
          }}
        />
      </InlineDisplayContent>

      <AddressInput
        value={{
          ...shippingOptions?.shippingAddress,
          company: shippingOptions?.shippingAddress?.company ?? shippingOptions?.companyName,
        }}
        onChange={(e) => {
          //if the company is the same as the address company, don't save it.
          //let it used the customer company as the address company
          if (e?.company === shippingOptions?.companyName) {
            delete e?.company
          }
          setShippingOptions({ shippingAddress: e })
        }}
        includeStreet3={true}
        includeCompany={true}
      />
    </>
  )
}
